// templatesColumns.js
import { Box, IconButton } from "@mui/material";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { formatDate } from "../../utils/formatDate";

const templatesColumns = (handleView, handleEdit, handleDelete, colors) => [
  {
    field: "name",
    headerName: "Nombre",
    flex: 1,
    cellClassName: "name-column--cell",
  },
  {
    field: "ticket_count",
    headerName: "Tickets",
    type: "number",
    headerAlign: "left",
    align: "left",
    flex: 1,
  },
  {
    field: "date",
    headerName: "Creada",
    flex: 1,
    valueFormatter: (value) => formatDate(value),
  },
  {
    field: "actions",
    headerName: "Acciones",
    headerAlign: "center",
    flex: 0.4,
    renderCell: (params) => (
      <Box display="flex" alignItems="center" justifyContent="center" gap="10px">
        <IconButton onClick={() => handleView(params.row.id)} sx={{ color: colors.grey[100] }}>
          <VisibilityOutlinedIcon />
        </IconButton>
        <IconButton onClick={() => handleEdit(params.row.id)} sx={{ color: colors.grey[100] }}>
          <EditOutlinedIcon />
        </IconButton>
        <IconButton onClick={() => handleDelete(params.row.id)} sx={{ color: colors.grey[100] }}>
          <DeleteOutlinedIcon />
        </IconButton>
      </Box>
    ),
  },
];

export { templatesColumns }